/**
 * Ensures Study Lab LLM dropdowns never collapse to only "saved" config values when
 * the vendor list API fails, returns empty, or the CMS parses an unexpected envelope.
 */
export const FALLBACK_LLM_MODELS = [
  { id: "gpt-5.2", provider: "openai" },
  { id: "gpt-5.1", provider: "openai" },
  { id: "gpt-5.1-chat-latest", provider: "openai" },
  { id: "gpt-5", provider: "openai" },
  { id: "gpt-4o", provider: "openai" },
  { id: "gpt-4o-mini", provider: "openai" },
  { id: "gpt-4-turbo", provider: "openai" },
  { id: "gpt-3.5-turbo", provider: "openai" },
  { id: "claude-3-5-sonnet-20241022", provider: "anthropic" },
  { id: "claude-3-sonnet-20240229", provider: "anthropic" },
  { id: "claude-3-haiku-20240307", provider: "anthropic" },
]

export function extractLlmCombinedFromResponse(raw) {
  if (!raw || typeof raw !== "object") return []
  const top = raw
  const nested = top.data !== undefined ? top.data : top
  const combined =
    nested?.combined ??
    nested?.data?.combined ??
    top.combined ??
    null
  return Array.isArray(combined) ? combined : []
}

export function extractLlmSourceFromResponse(raw) {
  if (!raw || typeof raw !== "object") return { openaiLive: false, anthropicLive: false }
  const nested = raw.data !== undefined ? raw.data : raw
  const inner = nested?.data !== undefined ? nested.data : nested
  return {
    openaiLive: inner?.openaiLive === true,
    anthropicLive: inner?.anthropicLive === true,
  }
}

/** Prefer live vendor list order; append any fallback ids not already present. */
export function mergeLlmCatalog(liveList) {
  const map = new Map()
  for (const m of Array.isArray(liveList) ? liveList : []) {
    if (!m || typeof m !== "object") continue
    const id = String(m.id || "").trim()
    if (!id) continue
    const provider =
      m.provider === "anthropic" || m.provider === "openai"
        ? m.provider
        : id.toLowerCase().startsWith("claude")
          ? "anthropic"
          : "openai"
    map.set(id, { id, provider })
  }
  for (const m of FALLBACK_LLM_MODELS) {
    if (!map.has(m.id)) map.set(m.id, { ...m })
  }
  return Array.from(map.values())
}
